import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http'
import {  Router } from "@angular/router";
import { gutil } from '../../gutil';
import {  PaymentService } from '../../services/payment.service';
import * as moment from 'moment';
import { faKey, faIdCard,faFaucet,faCouch,faBroom,faPlug,faTools,faCogs,faChevronLeft,faChevronRight, 
  faCheckCircle, faExclamationCircle, faTimesCircle, faUserCircle, faUser, faRupeeSign, faUsers, faFileAlt, faTimes, faBars, faShareAlt, faFile, faFileSignature, faToolbox, faHandsHelping, faCertificate, faReceipt } from '@fortawesome/free-solid-svg-icons';
import { getMonth } from 'ngx-bootstrap/chronos';




@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class TenantDashboardComponent implements OnInit {

  public faIdCard = faIdCard;
  public faReceipt = faReceipt;
  public faShareAlt = faShareAlt;
  public faFile = faFile;
  public faFileSign = faFileSignature;
  public faHandsHelping = faHandsHelping;
  public faCerti = faCertificate;
  public faUsers = faUsers;
  public faBars = faBars;
  public faRight = faChevronRight;
  public faLeft = faChevronLeft;
  public faUser = faUser;
  public faRupeeSign = faRupeeSign;
  public faKey = faKey;
  public faTools = faTools;
  public faFaucet = faFaucet;
  public faCouch = faCouch;
  public faBroom = faBroom;
  public faPlug = faPlug;
  public faCogs = faCogs;
  public faCheckCircle = faCheckCircle;
  public faExclamationCircle = faExclamationCircle;
  public faTimesCircle = faTimesCircle;
  public faUserCircle = faUserCircle;
  public faFileAlt = faFileAlt;
  public faTimes = faTimes;
  public dashboardScreen:boolean;
  public agreementScreen:boolean;
  public serviceScreen: boolean;
  public referalScreen: boolean;
  public documentScreen: boolean;
  public offerScreen: boolean;
  public rentDataLoader: number;
  public tenantProps:Array<any>;
  public onBoardingCheck:boolean = true;
  public percentage:number;
  public monthTime: number;
  public no_of_month: any;
  public payTyp:string;
  public payTypId: number;
  public agreepayTyp: any;
  public agreepayTypId: any;
  public isChecked: boolean;
  public agreePolicy: boolean;
  public tokenMoney:any;
  public tokenAmt:Array<any>;
  public rentRecps = [];
  public payschs:any;
  public depoRecps:any;
  public depositDate: any;
  public renewAgreementSel:any;
  public userexit = {pid:0,puid:0, exitdate:"", reason:""};
  public payRentTyp: string;
  public payRentTypId: number;
  public rentPaymentData: Array<any>;
  public rentAmount:any;
  public kycAcknowdata={user_id:"",consent:gutil.tokenPolicy,user_name:"",mobile_number:"",date:"",location_city:"",signature:""};
  public tokenCheck: boolean;
  public gatewaycheck:string;
  public token_payment:any;
  public rent_payment:any;
  public rentDataArray = [];
  public rentAmt = 0;
  public minExitDate:any;
  public displayDaysRem:any;
  public getDocsData:any;
  public getUniqDocs:any;
  public roomAllocationCheck:any;
  public documentCheck:boolean = false;
  public adharCheck:any;
  public isTokenDisabled: boolean = false;
  public isRoomAllocDisabled: boolean = true;
  public isDocumentDisabled: boolean = true;
  public isPayDepositDisabled: boolean = true;
  public isGenAgreemDisabled: boolean = true;
  public payDeposit:any;
  public tenantPropCheck:any;
  public daysLeft:any;

  public ServiceReqArr: Array<any>;
  public uniqueServiceRequest: Array<any>;
  public sReqs: Array<any>;
  public sReq = {type:0,subtype:0,user_id:0,property_id:0,room_id:0,status:1,detail:"" };
  public tenantData: Array<any>;
  public srReqTypesSel: any;

  public srPending: any= 0;
  public srClosed: any= 0;

  public srKeys:any=0;
  public srKeysPend: any = 0;
  public srKeysClosed:any;

  public srPlumbing: any=0;
  public srPendingPlumbing:any=0;
  public srClosedPlumbing:number=0;


  public srFurnishing: any=0;
  public srPendingFurnishing:any=0;
  public srClosedFurnishing:any=0;

  public srElectrical: any=0;
  public srElectricalClosed:any=0;
  public srElectricalPend:any=0;

  public srCleaning: any=0;
  public srCleaningClosed: any= 0;
  public srCleaningPending: any=0;

  public srCarpentry: any=0;
  public srClosedCarpentry:any=0;
  public srPendingCarpentry:any=0;

  public srOthers: any=0;
  public srOthersClosed:any=0;
  public srOthersPending:any=0;
  public sRequestData:Array<any>;
  public selectedTyp:string;
  public sRequestTotal:number;

  public showSpinner = true;
  public id:any;
  public user:any;
  public t_dashboard_loader : boolean;
  public pro_img:any;
  public referenceCheck:boolean = false;
  public agreement_pdf:any;
  public getPaymentConsent:any;
  public userCheck:boolean;
  public serviceType:any;
  public srTitle:any;
  public service_id:number;
  public srDetail = [];
  public sRTotal:any;
  public sRData:any;
  public testimonial = [];
  public sPolicy = {user_id:0,paymenttype:"",paytypeid:0,content:""};
  public tenantName:string;
  public payAmtRazorPay: any;
  public payAmtPaytm : any;
  public qrcodeval : any;
  public loadingMsg : string;

  constructor(private http: HttpClient,private paymentService: PaymentService,private router: Router) {

    this.renewAgreementSel = gutil.renewAgreementSel;
    this.srReqTypesSel = gutil.srTypesSel;
   }

  ngOnInit(): void {
    this.user = gutil.user;
    this.t_dashboard_loader = true;
    this.sReq.type = 0;
    this.fetchDashboardFunctions();
    this.token_payment = 'razor';
    this.rent_payment = 'razor';
    this.userexit.exitdate = 'Choose Date';
    this.minExitDate = moment().add(31, 'days').format('YYYY-MM-DD');
    var tenantFullName = this.user.name.split(" "); 
    this.tenantName = tenantFullName[0];
    this.loadingMsg = 'Please wait. Fetching data might take a few minutes.';
    // setTimeout(() => {
    //   document.getElementById('sidebar_toggle').classList.add('animate');
    // }, 3000)
    
  }

  public async fetchDashboardFunctions() {
    this.fetchTenantPropData();
   
    
    this.fetchPSchedules();
    this.fetchSRData();
    this.getDocuments();
    this.getProfileImage();
    this.getParameter('dashboard');
    this.fetchHomeTestimonial();
  }
  public getParameter(id: string) {

    this.router.navigate(['/profile/tenant/' + id]);
    
    if(id == 'dashboard') {
      this.dashboardScreen = true;
      this.agreementScreen = false;
      this.serviceScreen = false;
      this.referalScreen = false;
      this.documentScreen = false;
      this.offerScreen = false;
    }
    else if(id == 'document') {
      this.documentScreen = true;
      this.dashboardScreen = false;
      this.agreementScreen = false;
      this.serviceScreen = false;
      this.referalScreen = false;
      this.offerScreen = false;
    }
    else if(id == 'agreement') {
      this.agreementScreen = true;
      this.serviceScreen = false;
      this.dashboardScreen = false;
      this.documentScreen = false;
      this.referalScreen = false;
      this.offerScreen = false;
    }
    else if(id == 'service') {
      this.serviceScreen = true;
      this.dashboardScreen = false;
      this.agreementScreen = false;
      this.documentScreen = false;
      this.referalScreen = false;
      this.offerScreen = false;
    }
    else if(id == 'referal') {
      this.referalScreen = true;
      this.serviceScreen = false;
      this.dashboardScreen = false;
      this.agreementScreen = false;
      this.documentScreen = false;
      this.offerScreen = false;
    }
    else if(id == 'offers') {
      this.offerScreen = true;
      this.referalScreen = false;
      this.serviceScreen = false;
      this.dashboardScreen = false;
      this.agreementScreen = false;
      this.documentScreen = false;
    }
    
  }

///////////////////////////////////////// Circular Progress Bar Data ////////////////////////////////////////////////
  public async fetchProgressBarData() {
    this.http.get(gutil.devapiUrl + '/api/v1/property/tenant/' + this.user.id +'/dashboard?api_token=' + this.user.api_token)
      .subscribe((data : any) => {
        this.tenantProps = data.obj
        let occupiedto = this.tenantProps[0].occupto;
        this.showSpinner = true;
        var c = moment(occupiedto).diff(moment(), "months");
        this.percentage = (100/12)*c;
        this.monthTime = (100/12)*c;
        this.no_of_month = c;
        if(this.monthTime == 0) {
          this.showSpinner = false;
          this.displayDaysRem = true;
          /////Find days left////////////
          this.daysLeft = moment(occupiedto).diff(moment(), "days");
        }
      }, 
      error => console.error(error)); 
      
  }
////////////////////////////////TS for Dashboard starts here//////////////////////////////
  public async fetchTenantPropData() {
        this.http.get(gutil.devapiUrl + '/api/v1/property/tenant/' + this.user.id +'/dashboard?api_token=' + this.user.api_token)
            .subscribe((data:any) => { 
              
              this.tenantProps = data.obj;
              
              if(this.tenantProps.length == 0 || this.tenantProps.length == null || this.tenantProps.length == undefined) 
              {
                this.tenantPropCheck = 0;
                this.t_dashboard_loader = false;
              }
              else if(this.tenantProps.length > 0  && this.tenantProps[0].property_id > 0) 
              {
                this.tenantPropCheck = 1;
                this.onBoardingCheck = true;
                this.fetchTokenPay();
                this.fetchProgressBarData();
              }  
        });
        
  }
  
  public async fetchTokenPay() {
    // this.t_dashboard_loader = true;
    // this.t_dashboard_loader = false;
    this.loadingMsg = 'Fetching token details';
    this.http.get(gutil.devapiUrl + '/api/v1/payment/schedules/' + this.user.id + '?api_token=' + this.user.api_token)
      .subscribe((data: any) => {
        if(this.tenantProps[0].occupfrom >= '2021-09-01'){
          if(data.obj[0] != undefined){
            this.isTokenDisabled = true;
            this.isRoomAllocDisabled = false;
            this.tokenCheck = true;
            this.fetchDocumentInfo();
            // for(let i in data.obj){
            //   if(data.obj[i].inv_startdate == data.obj[i].inv_enddate){
            //     if(data.obj[i].status == 2){
            //       this.isTokenDisabled = true;
            //       this.isRoomAllocDisabled = false;
            //       this.tokenCheck = true;
            //       this.roomAlloc();
            //     }else{
            //       // this.tokenMoney = data.obj[0].amount;
            //       this.t_dashboard_loader = false;
            //     }
            //   }else{
            //     // this.tokenMoney = data.obj[0].amount;
            //     this.t_dashboard_loader = false;
            //   }
            // }
            
          }
          else{
            // this.tokenMoney = data.obj[0].amount;
            this.t_dashboard_loader = false;
          }
        }else{
          this.isTokenDisabled = true;
          this.isRoomAllocDisabled = true;
          this.tokenCheck = true;
          this.onBoardingCheck = false;
          this.t_dashboard_loader = false;
        }
      }) 
  }

  // public async roomAlloc() {
  //   this.loadingMsg = 'Fetching room allocation.';
  //     this.isRoomAllocDisabled = false;
  //     if(this.user.name!="" && this.user.email!="" && this.user.phone!="" && this.user.father_name!="" && this.user.mother_name!="" && this.user.addressl1!="" && this.user.zipcode!="" &&this.user.city!="" && this.user.state!="" && this.user.gender!="" && this.user.occupation!="" && this.user.nationality!="" && this.user.adhaar_number!="" && this.user.bank_account!=""&& this.user.bank_ifsc!=""){
  //       this.http.get(gutil.devapiUrl + '/api/v1/Roomallocation/getdata/' + this.user.id + '?api_token=' + this.user.api_token).subscribe((data: any) => {
  //         if(data.obj.property_id > 0 && data.obj.room_id >= 0 && data.obj.Confirmation == 1) {
  //             this.isRoomAllocDisabled = true;
  //             this.fetchDocumentInfo();
  //         }
  //         else{
  //           this.t_dashboard_loader = false;
  //         }
  //       })
        
  //     }else{
  //       this.t_dashboard_loader = false;
  //     }
  // }
  public async fetchDocumentInfo() {
      
      this.isDocumentDisabled = false;
      let docCheck = 0;
      let refCheck = 0;
      this.loadingMsg = 'Fetching documents and references.';
      this.http.get(gutil.devapiUrl + '/api/v1/documents/info/' + this.user.id + '?api_token=' + this.user.api_token)
          .subscribe((data:any) => {
            if(data.length > 1) {
              for(let doc = 0 ; doc < data.data.length ; doc++){
                if(data.data[doc].type != "rent"){
                  if(data.data[doc].status == 10){
                    docCheck += 1;
                    
                  }else{
                    docCheck = docCheck
                    this.t_dashboard_loader = false;
                  }
                }
              }
              
              if(docCheck >= 2){ 
                
                this.documentCheck = true;
                this.http.get(gutil.devapiUrl + '/api/v1/references/info/user/' + this.user.id +'?api_token=' + this.user.api_token)
                  .subscribe((data:any) => {
                    if(data.obj.length > 1) {
                      
                      for(let ref = 0 ; ref < data.obj.length; ref++){
                        if(data.obj[ref].status == 2){
                          refCheck += 1;
                        }else{
                          this.referenceCheck = false;
                        }
                      }
                      if(refCheck >= 2 ){
                        this.referenceCheck = true;
                      }else{
                        this.t_dashboard_loader = false;
                      }
                      if( this.documentCheck = true && this.referenceCheck == true) {
                        this.isDocumentDisabled = true;
                        this.fetchPayDeposit();
                      }else{
                        this.t_dashboard_loader = false;
                      }
                    }
                    else{
                      this.t_dashboard_loader = false;
                    }
                  })
              }else{
                this.t_dashboard_loader = false;
              }
            }
            else{
              this.t_dashboard_loader = false;
            }
          })
  }
  public async fetchPayDeposit() {
    this.loadingMsg = 'Fetching deposit status.';
    this.isPayDepositDisabled = false;
      this.http.get(gutil.devapiUrl + '/api/v1/property/tenant/' + this.user.id + '/dashboard?api_token=' + this.user.api_token)
          .subscribe((data: any) => {
            if(data.obj[0].pendingdeposite == 0 && data.obj[0].deposite > 0) {
              this.isPayDepositDisabled = true;
              this.payDeposit = true;
              this.generateAgreement();
            }else{
              this.t_dashboard_loader = false;
            }
          })
  }
  public async generateAgreement() {
    this.loadingMsg = 'Fetching aggrement status.';
    this.isGenAgreemDisabled = false;
      this.http.get(gutil.devapiUrl + '/api/v1/documents/info/' + this.user.id + '?api_token=' + this.user.api_token)
        .subscribe((data:any) => {
          for(let i = 0; i < data.length; i++) {
            if(data.data[i].type == 'rent' && data.data[i].status == 10) {
              this.onBoardingCheck = false;
              this.t_dashboard_loader = false;
            }else{
              this.t_dashboard_loader = false;
            }
          }
        })
  } 
  public genAgree() {
    this.router.navigate(['/profile/tenant/']);
  }
  mailContact() {
    var mail = document.createElement("a");
    mail.href = "mailto:care@yourownroom.com?subject=Contact to YourOwnRoom&body=Hi";
    mail.click();
    this.router.navigate['/profile/tenant'];
  }

  

  showHideSubmit($event: any){
    if(this.isChecked) {
      this.agreePolicy = true;
    }
    else {
      this.agreePolicy = false;
    }
  }

  public savePolicy(agreepayTyp:string,agreepayTypId:number) {
    this.payTyp = agreepayTyp;
    this.payTypId = agreepayTypId;
    // this.showPayPopup(this.payTyp,this.payTypId)
  }

  
  // public showRTblPopup(rentRec:any){
  //   if(this.rentRecps.length > 0){
  //       this.modalService.open(rentRec);
  //   } 
  // }
  public async fetchPSchedules(){
    this.http.get(gutil.devapiUrl + '/api/v1/payment/schedules/' + this.user.id + '?api_token=' + this.user.api_token )
        .subscribe((data:any) => {
          this.payschs = data.obj;
          if(data.payschs != -1) {
            let di = 0;
            let ri = 0;
            let d : Date; 
            for(let psi in this.payschs) {
              d = new Date(this.payschs[psi].schldate);
              this.payschs[psi].dispMonth = gutil.monthNames[d.getMonth()] + ", " + d.getFullYear();
                if(this.payschs[psi].objecttype == "rent" && this.payschs[psi].status == 2) {
                    this.rentRecps[ri] = this.payschs[psi];
                    ri++;
                }
                else if(this.payschs[psi].objecttype == "depositeroom" || this.payschs[psi].objecttype == "depositeproperty") {
                    this.depoRecps = this.payschs[psi];
                    this.depositDate = this.depoRecps.created_at;
                    this.depositDate = moment(this.depositDate).format("D-MMM-YYYY");
                    di++;
                }
            }
          }
          
        },
        err => console.error(err)
        );
  }

  public changeExitReason(value: any) {
    this.userexit.reason = value;
  }
  public changeExitDate(value: any) {
    this.userexit.exitdate = value;
  }

  public initiateExitProcess(puid:number,pid:number) {
    this.userexit.puid=puid;
    this.userexit.pid = pid;
  }

  public initExit() {
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    let options =  {headers: headers }; 
    let params = new URLSearchParams();
    let d = new Date(this.userexit.exitdate);
    
    params.append('exit_date', d.getFullYear() + "-" + (d.getMonth()<9 ? "0"  : ""  ) + (d.getMonth()+1) + "-" + (d.getDate()<10 ? "0"  : ""  ) + d.getDate());
    params.append('exit_reason', this.userexit.reason);
    params.append('uid', "" + this.user.id);
    params.append('puid', "" + this.userexit.puid);
    params.append('pid', "" + this.userexit.pid);
    params.append('exit_status', '1');

    let paramsString = params.toString();
    this.http.post(gutil.devapiUrl + '/api/v1/user/updateexitrequest?api_token=' + this.user.api_token, paramsString, options)
        .subscribe((data) => {
          console.log("Success!");
        });
        this.router.navigate(['/profile/tenant/']);
  }
  public showRentPaymentPopup(rentPayTyp:string, rentPayTypId:number) {
    this.payRentTyp = rentPayTyp;
    this.payRentTypId = rentPayTypId;
    this.rentDataLoader = 0;
    this.http.get(gutil.devapiUrl + '/api/v1/payment/schedules/' + this.user.id + '?api_token=' + this.user.api_token)
        .subscribe((data:any)=> {
          this.rentPaymentData = data.obj;
          this.rentDataLoader = 0;
          let rda = 0;
          let currDate = new Date();
          let currMonth = currDate.getMonth() + 1;
          let currYear = currDate.getFullYear();
          for(let rent in this.rentPaymentData) {
            if(this.rentPaymentData[rent].objecttype == "rent" && this.rentPaymentData[rent].status == 1) {
              let invDate = new Date(this.rentPaymentData[rent].inv_startdate);
              let invMonth = invDate.getMonth() + 1;
              let invYear = invDate.getFullYear();
              if( invYear < currYear){
                this.rentDataArray[rda] = Number(this.rentPaymentData[rent].amount);
                rda++;
              }
              else if(invYear == currYear){
                if(invMonth <= currMonth){
                  this.rentDataArray[rda] = Number(this.rentPaymentData[rent].amount);
                  rda++;
                }
              }
              else{
                continue;
              }

            }
          }
          let rentAmt = 0;
          
          for(let num of this.rentDataArray) {
            rentAmt = rentAmt + num;
            this.rentAmount = rentAmt;
          }
          
          var convFeeAmt = this.rentAmount*(1.75/100) + this.rentAmount*(1.75/100)*0.18;
          this.payAmtRazorPay = this.rentAmount + Math.round(convFeeAmt);
          this.payAmtPaytm = this.rentAmount;
          this.qrcodeval = "upi://pay?pa=yourownroom@dbs&pn=YourOwnRoom&tr="+rentPayTypId+"&tn="+this.user.name+"&am="+this.rentAmount+"&cu=INR&mode=01&orgid=000000";
          this.rentDataLoader = 1;
          this.setDefaultGateway('razor');
        })
  }
  public onTokenBtnClick(payTyp:string, payTypId:number){
    
    this.payRentTyp = payTyp;
    this.payRentTypId = payTypId;
    this.tokenMoney = this.tenantProps[0].rent;
    var convFeeAmt = this.tokenMoney*(1.75/100) + this.tokenMoney*(1.75/100)*0.18;
    this.payAmtRazorPay = this.tokenMoney + convFeeAmt;
    this.payAmtPaytm = this.tokenMoney;
    this.qrcodeval = "upi://pay?pa=yourownroom@dbs&pn=YourOwnRoom&tr="+this.tenantProps[0].id+"&tn="+this.user.name+"&am="+this.tokenMoney+"&cu=INR&mode=01&orgid=000000";

  }
  public changegateway(value:any){
    this.gatewaycheck = value.target.defaultValue;
    this.gatewayEventFallback(this.gatewaycheck); 
  } 
  public setDefaultGateway(value:any){
    this.gatewaycheck = value;
    this.gatewayEventFallback(this.gatewaycheck); 
  }

  private gatewayEventFallback(value:any){
    if(value == "razor"){
        this.rentAmount = this.payAmtRazorPay;
    }
    if(value == "paytm"){
      this.rentAmount = this.payAmtPaytm;
    }
  }

  public initPayment() {
    // this.paymentService.initiatePayment
    // console.log(this.payRentTypId , this.rentAmount, this.payRentTyp , "Proceed for payment of Rs. " + this.rentAmount , "", undefined , this.gatewaycheck);
    this.paymentService.initiatePayment(this.payRentTypId , this.rentAmount, this.payRentTyp , "Proceed for payment of Rs. " + this.rentAmount , "", undefined , this.gatewaycheck);
    
  }
  
  public async getProfileImage() {

    this.http.get(gutil.devapiUrl + '/api/v1/user/info?api_token=' + this.user.api_token)
        .subscribe((data:any) => {
          if(data.obj.images.length > 0){
            for(let im = 0; im < data.obj.images.length; im++) {
              if(data.obj.images[im].size == 'thb') {
                this.pro_img = data.obj.images[im].url;
              }
            }
          }
          
        })
  }
/////////////////////////////////// TS for Dashboard ends here////////////////////////////////////////////////////
/////////////////////////////////////////// TS for Service Screeen start ////////////////////////////////////////////
public onTypeChange(value:any) {
    this.sReq.type = value;
}
public changeSRDetail(value:any){
  this.sReq.detail = value.target.value;
}
public newSReqPopup(pid:any, rid:any) {
  this.sReq.user_id = this.tenantProps[0].user_id;
  this.sReq.property_id = pid;

  if(rid !== undefined && rid > 0) {
    this.sReq.room_id = rid;
  }
}

public submitSRequest() {
  let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
  let options =  {headers: headers };
  let params = new URLSearchParams();
    for(let x in this.sReq){   
        params.append(x, this.sReq[x]);
    }
  let paramsString = params.toString(); 
  this.http.post(gutil.devapiUrl + '/api/v1/services/edit?api_token=' + this.user.api_token , paramsString, options)
      .subscribe((data) => {
          console.log("Success!");
      });  
      this.router.navigate(['/profile/tenant/']);     
}

public async fetchSRData() {
  this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id + '?api_token=' + this.user.api_token)
    .subscribe((data:any) => {
      this.sRequestTotal = data.total;
      this.sRequestData = data.data; 

      //////Array of Unique Elements consisting of ServiceRequestType id///////
      this.ServiceReqArr = this.sRequestData; 
      this.uniqueServiceRequest = this.ServiceReqArr.map(item => item.type).filter((value, index , self)=> self.indexOf(value) === index);
      this.uniqueServiceRequest.sort()
      ///////// Array ends here/////////

      for(let i = 0 ; i < this.sRequestData.length ; i++){
        //Data loop for Pending and Closed Requests
        if(this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1 ){
            this.srPending += 1;
        }
        else if(this.sRequestData[i].status == 5){
            this.srClosed += 1;
        }
        //Keys Data loop
        if(this.sRequestData[i].type == 1) {
          this.srKeys +=1;
          if(this.sRequestData[i].type == 1 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srKeysPend +=1;
          }
          else if(this.sRequestData[i].type == 1 && this.sRequestData[i].status == 5) {
            this.srKeysClosed +=1;
          }
        }
        //Plumbing Data loop
        if(this.sRequestData[i].type == 12) {
          this.srPlumbing +=1;
          if(this.sRequestData[i].type == 12 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srPendingPlumbing +=1;
          }
          else if(this.sRequestData[i].type == 12 && this.sRequestData[i].status == 5) {
            this.srClosedPlumbing +=1;
          }
        }
        //Furnishing Data Loop
        if(this.sRequestData[i].type == 17) {
          this.srFurnishing +=1;
          if(this.sRequestData[i].type == 17 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srPendingFurnishing +=1;
          }
          else if(this.sRequestData[i].type == 17 && this.sRequestData[i].status == 5) {
            this.srClosedFurnishing +=1;
          }
        }
        //Cleaning Data Loop
        if(this.sRequestData[i].type == 47) {
          this.srCleaning +=1;
          if(this.sRequestData[i].type == 47 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srCleaningPending +=1;
          }
          else if(this.sRequestData[i].type == 47 && this.sRequestData[i].status == 5) {
            this.srCleaningClosed +=1;
          }
        }
        //Electrical Data loop
        if(this.sRequestData[i].type == 49) {
          this.srElectrical +=1;
          if(this.sRequestData[i].type == 49 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srElectricalPend +=1;
          }
          else if(this.sRequestData[i].type == 49 && this.sRequestData[i].status == 5) {
            this.srElectricalClosed +=1;
          }
        }
        //Carpentry Data loop
        if(this.sRequestData[i].type == 51) {
          this.srCarpentry +=1;
          if(this.sRequestData[i].type == 51 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srPendingCarpentry +=1;
          }
          else if(this.sRequestData[i].type == 51 && this.sRequestData[i].status == 5) {
            this.srClosedCarpentry +=1;
          }
        }
        //Others Data loop
        if(this.sRequestData[i].type == 60) {
          this.srOthers +=1;
          if(this.sRequestData[i].type == 60 && (this.sRequestData[i].status == 2 || this.sRequestData[i].status == 1)) {
            this.srOthersPending +=1;
          }
          else if(this.sRequestData[i].type == 60 && this.sRequestData[i].status == 5) {
            this.srOthersClosed +=1;
          }
        }
      } 
  });
  }
///////////////////////////////// TS for document screen//////////////////////////////////////////////////////
  public async getDocuments() {
    this.http.get(gutil.devapiUrl + '/api/v1/documents/info/' + this.user.id + '?api_token=' + this.user.api_token)
        .subscribe((data: any) => {
          this.getDocsData = data.data;
          for(let doc = 0; doc < data.length; doc++) {
            if(this.getDocsData[doc].type == 'rent') {
              this.agreement_pdf = this.getDocsData[doc].url;
            }
          }
        })
  }

  public openDocs(url: string){
    window.open(url , '_blank');
  }

/////////////////////////////////////////////// TS for Agreement Screen ///////////////////////////////////////////
  public showRentAggr(){
    window.open(this.agreement_pdf, '_blank');
    
  }
///////////////////////////////////////////////////TS for 'view service request' //////////////////////////////////
  public serviceRequestDetail(id : number) {
    this.service_id = id;
    this.http.get(gutil.devapiUrl + '/api/v1/services/info/' + this.user.id  + '?api_token=' + this.user.api_token)
        .subscribe((data:any)  =>{
          this.sRTotal = data.total;
          this.sRData = data.data; 
        
          let sr = 0;
          this.srDetail = [];
          for(let i = 0; i < this.sRData.length; i++) {
            if(this.service_id == this.sRData[i].type) {
              this.srDetail[sr] = this.sRData[i];
              sr++;
            }
          }
        })
  }
///////////////////////////////////////// TS for Testimonial and News ////////////////////////////////////////
public newsRight() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'right',25,150,50);
  }
  public newsLeft() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'left',25,150,50);
  }
  public scrollRight() {
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'right',25,150,50);
  }
  public scrollLeft() {
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'left',25,150,50);
  }
  public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
    let scrollAmount = 0;
    let slideTimer = setInterval(function(){
      if(direction == 'left'){
        element.scrollLeft -= step;
      }else{
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >=distance ){
        window.clearInterval(slideTimer);
      }
    }, speed)
  }
  public fetchHomeTestimonial() {
    this.http.get(gutil.devapiUrl + '/api/w/v1/testimony/details')
        .subscribe((data: any)=> {
          
          let t = 0;
          for(let r = 0; r < data.obj.length; r++) {
            if(data.obj[r].role == 1) {
              this.testimonial[t] = data.obj[r];
              t++;
            }
          }
        })
  }
}